import { useRef } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';

import { Wrapper } from './inline_svg.styles';

const idRegExp = new RegExp('id="', 'g');
const urlRegExp = new RegExp('url\\(#', 'g');
const xlinkRegExp = new RegExp('xlink:href="#', 'g');

/* eslint-disable react/no-danger */

export default function InlineSvg({ children = '', height, width }) {
  const baseId = useRef(nanoid());

  const sanitizedContent = children
    .replace('<?xml version="1.0" encoding="UTF-8"?>', '')
    .replace(idRegExp, `id="${baseId.current}__`)
    .replace(urlRegExp, `url(#${baseId.current}__`)
    .replace(xlinkRegExp, `xlink:href="#${baseId.current}__`)
    .trim();

  return (
    <Wrapper width={width} height={height} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
  );
}

InlineSvg.propTypes = {
  children: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
